import {getAccessToken} from '../../services/tokens';
import {customFetch} from '../utils/fetch';

const getPersonalData = (successCallback, errorCallback) => {
  customFetch({
    url: 'users/profile',
    domain: window.Site?.authDomain,
    method: 'GET',
    headers: {
      Authorization: `Bearer ${getAccessToken()}`
    }
  })
    .then(response => (response?.error ? errorCallback(response) : successCallback(response)))
    .catch(error => errorCallback(error));
};

const updatePersonalData = async (data, successCallback, errorCallback) => {
  customFetch({
    url: 'users/profile',
    domain: window.Site?.authDomain,
    method: 'PATCH',
    body: JSON.stringify(data),
    headers: {
      Authorization: `Bearer ${getAccessToken()}`
    }
  })
    .then(response => (response?.error ? errorCallback(response) : successCallback(response)))
    .catch(error => errorCallback(error));
};

export {getPersonalData, updatePersonalData};
